import React, { useContext, useState } from "react";
import { Modal, Input, Button, Container } from "semantic-ui-react";
import { RateStoreContext } from "../../stores/RateStore";
import { AppStoreContext } from "../../stores/AppStore";
import { runInAction } from "mobx";
import { observer } from "mobx-react-lite";
import "./ModalNegotiateNeeded.css";
import { GLOBAL_MODALS } from "../../stores/modals";
import { useTranslation } from "react-i18next";
export default observer(function ModalNogotiateNeeded() {
  const appStore = useContext(AppStoreContext);
  const rateStore = useContext(RateStoreContext);
  const [t] = useTranslation();
  const {
    rangeLow,
    rangeHigh,
    setNegotiated,
    declineNegotiated,
    isSaving
  } = rateStore;

  const [lastClicked, setLastClicked] = useState("");

  const onRateChange = (e, { value }) => {
    // only care about the numeric value
    rateStore.rateAmount = parseInt(value.replace(/[^\d]*/g, ""), 10) || 0;
  };

  const acceptClick = () => {
    setLastClicked("accept");
    setNegotiated().catch(() =>
      runInAction(() => (appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR))
    );
  };

  const declineClick = () => {
    setLastClicked("decline");
    declineNegotiated().catch(() =>
      runInAction(() => (appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR))
    );
  };

  return (
    <Modal
      dimmer="blurring"
      defaultOpen={true}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      size="small"
    >
      <Modal.Content>
        <Container fluid textAlign="center" style={{ padding: "1rem" }}>
          <p>
            {t("rate_negotiate_modal_message1", { amount1: rangeLow, amount2: rangeHigh})}
          </p>
        </Container>
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={declineClick}
          loading={isSaving && lastClicked === "decline"}
          disabled={isSaving}
          secondary
          floated="left"
        >
          Cancel
        </Button>
        <Input
          icon="dollar sign"
          iconPosition="left"
          type="text"
          value={rateStore.rateAmount}
          onChange={onRateChange}
          disabled={isSaving}
          style={{ width: 120 }}
        />
        <Button
          onClick={acceptClick}
          loading={isSaving && lastClicked === "accept"}
          disabled={isSaving}
          primary
        >
          {t("rate_negotiate_modal_submit_label")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
});
